<template>
  <!-- Start Single List -->
  <div>
    <div
      class="single-item-list"
      v-for="favorite in favorites"
      :key="favorite.id"
    >
      <div class="row align-items-center">
        <div class="col-lg-5 col-md-5 col-12">
          <div class="item-image">
            <img :src="favorite.Product.imgUrl" alt="Product Image" />
            <div class="content">
              <h3 class="title">
                <a @click.prevent="seeProduct(favorite.Product.id)" href="">{{
                  favorite.Product.name
                }}</a>
              </h3>
              <span class="price">{{ favorite.Product.price }}</span>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-12">
          <p>{{ favorite.Product.Category.name }}</p>
        </div>
        <div class="col-lg-2 col-md-2 col-12">
          <p>{{ favorite.createdAt }}</p>
        </div>
        <div class="col-lg-2 col-md-2 col-12 align-right">
          <ul class="action-btn">
            <li>
              <a @click.prevent="seeProduct(favorite.Product.id)"
                ><i class="lni lni-eye"></i
              ></a>
            </li>
            <li>
              <a @click.prevent="removeFavorite(favorite.id)"
                ><i class="lni lni-trash"></i
              ></a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- End Single List -->
  </div>
</template>

<script>
export default {
  name: "FavoriteItem",
  computed: {
    favorites() {
      var options = {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "2-digit",
        hour: "numeric",
        minute: "numeric",
      };
      let formattedFavorites = this.$store.state.userFavorites;
      formattedFavorites.map((favorite) => {
        favorite.Product.price = Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "IDR",
        }).format(favorite.Product.price);
        favorite.createdAt = new Date(favorite.createdAt).toLocaleDateString(
          "en-US",
          options
        );
      });
      return formattedFavorites;
    },
  },
  methods: {
    seeProduct(productId) {
      this.$router.push(`products/${productId}`).catch(()=>{})
    },
    removeFavorite(payload) {
      this.$store.dispatch("removeFavorites", payload)
        .then(({ data }) => {
          this.$store.dispatch("fetchFavorites");
          this.$router.push("/favorites").catch(()=>{})
          this.$swal.fire({
            position: "top-end",
            icon: "success",
            title: data.message,
            text: data.email,
            showConfirmButton: false,
            timer: 1500,
          });
        })
        .catch((err) => {
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: err.response.data.message,
            showCloseButton: true,
            showConfirmButton: false,
          });
        });
    },
  },
  created() {
    this.$store.dispatch("fetchFavorites");
    
  },
};
</script>

<style>
</style>